import React from 'react';
import Avatar from '../../components/Avatar';

const Message = ({ author, isMe, text, attachments, scrollToBottom, ...rest }) => {
  return (
    <div className={`msg-box my-2 ${isMe ? 'me' : ''}`} {...rest}>
      <Avatar size={48} image={author.avatar} />
      <p>
        {!!text && text}
        {!!attachments && <img src={attachments[0].url} className="img-fluid" alt="image" onLoad={scrollToBottom} />}
      </p>
    </div>
  );
};

export default Message;
